import { mappingStatusParams } from '../../../models/products'

const mappingStatus = (query: mappingStatusParams) => {
  if (query?.blocklist) {
    delete Object.assign(query, { blocklist_action: query.blocklist }).blocklist
  }

  if (query?.status && query.status.includes('PROCESSING')) {
    const status = query.status
      .filter(item => !item.includes('PROCESSING'))
      .concat(['WAITING_PUBLICATION', 'WAITING_UPDATE'])
    return { ...query, status }
  }

  if (query?.status?.length && query?.status__ne) {
    const { status__ne, ...newQuery } = query
    return newQuery
  }

  if (query?.in === 'sku' && query?.status__ne) {
    const { status__ne, ...newQuery } = query
    return newQuery
  }

  return query
}

export default mappingStatus
